export default "__VITE_ASSET__hi4GWmSm__"